var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtopicAudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3047 27.9922C22.9321 27.9922 28.3047 22.6196 28.3047 15.9922C28.3047 9.36477 22.9321 3.99219 16.3047 3.99219C9.67727 3.99219 4.30469 9.36477 4.30469 15.9922C4.30469 22.6196 9.67727 27.9922 16.3047 27.9922Z",
    fill: "url(#paint0_linear_3930_6640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.1084V16.5217C16.2201 16.4166 15.924 16.3613 15.625 16.3584C14.1725 16.3584 13 17.5309 13 18.9834C13 20.4359 14.1725 21.6084 15.625 21.6084C16.9725 21.6084 18.075 20.5876 18.2208 19.2751H18.25V12.8584H19.7083C20.1916 12.8584 20.5833 12.4666 20.5833 11.9834C20.5833 11.5001 20.1916 11.1084 19.7083 11.1084H16.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3930_6640",
    x1: 16.3047,
    y1: 3.99219,
    x2: 16.3047,
    y2: 27.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtopicAudioIcon);
export default __webpack_public_path__ + "static/media/subtopic-audio-icon.d6b9d9deb2d997e635cdd063dc9c73db.svg";
export { ForwardRef as ReactComponent };